import { FC } from 'react'
import { UserAvatar, UserAvatarProps } from '../UserAvatar'
import { cn } from '@wellesley/ui'
import { Check } from 'lucide-react'
import CustomTooltip from 'components/CustomTooltip'
import { getDisplayUsername } from '../../helpers/getDisplayUsername'

export type UserCardProps = Pick<UserAvatarProps, 'imgUrl'> & {
  username: string
  displayName: string
  className?: string
  avatarClassName?: string
  onlyAvatar?: boolean
  hasCheckIcon?: boolean
  disabled?: boolean
  userTextClassname?: string
}
export const UserCard: FC<UserCardProps> = ({
  username,
  displayName,
  avatarClassName,
  imgUrl,
  disabled = false,
  className,
  onlyAvatar,
  hasCheckIcon,
  userTextClassname,
}) => (
  <div
    className={cn(
      'flex w-full flex-row items-center justify-between',
      disabled && 'pointer-events-none opacity-[0.7]',
      className,
    )}
  >
    <UserAvatar
      name={displayName}
      imgUrl={imgUrl}
      className={cn('h-10 w-10 2xl:h-14 2xl:w-14', avatarClassName)}
    />
    {!onlyAvatar && (
      <div
        className={cn(
          'ml-xxs mr-auto min-w-0 max-w-full text-base',
          userTextClassname,
        )}
      >
        <div className="truncate font-semibold text-gray-900">
          <CustomTooltip tooltipText={displayName}>{displayName}</CustomTooltip>
        </div>
        <div className="flex truncate text-gray-500">
          <CustomTooltip tooltipText={getDisplayUsername(username)}>
            {getDisplayUsername(username)}
          </CustomTooltip>
        </div>
      </div>
    )}
    {hasCheckIcon && (
      <Check size={20} color="var(--gray-900)" className="ml-xxs min-w-5" />
    )}
  </div>
)
